import * as React from "react";

type LogoProps = {
  title?: string;
  size?: number;
};

export default function Logo({ title = "Mile High Center of Ihsan", size = 34 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="ihsanGradient" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor="#8DA47E" />
          <stop offset="100%" stopColor="#6BA6C9" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="18" fill="#FAFAFA" stroke="rgba(18,23,20,0.12)" />
      <path
        d="M14 42 L28 26 L36 34 L44 24 L54 42 Z"
        fill="url(#ihsanGradient)"
        opacity="0.92"
      />
      <path
        d="M32 22c-2.9 0-5.2 2.3-5.2 5.2 0 5.8 5.2 8.9 5.2 8.9s5.2-3.1 5.2-8.9c0-2.9-2.3-5.2-5.2-5.2Z"
        fill="#8DA47E"
        opacity="0.95"
      />
    </svg>
  );
}

